import { Component, Input } from '@angular/core';
import { PropertyFormService } from '../../services/property-form.service';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'property-form-photos',
  templateUrl: './property-form-photos.component.html',
  styleUrls: ['./property-form-photos.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIcon,
    MatFormField,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PropertyFormPhotosComponent {

  @Input() propertyFormService!: PropertyFormService;

  panelOpen = false;
  panelOpenedOnce = false;

  handleDeletePropertyPhoto(id: string) {
    this.propertyFormService.deletePhoto(id);
  }

  handleUpdatePropertyPhoto(id: string, event: any) {
    this.propertyFormService.updatePhoto(id, event.target.value);
  }

  handleAddPropertyPhoto() {
    this.propertyFormService.addPhoto();
  }

  trackByFn(_index: number, item: any) {
    return item.id;
  }
}